<small class="{{ type() }} {{ size() }} {{ styleClass() }}">{{
  value()
}}</small>

<!-- TODO look into ion-note -->
